{
  "settings.appearance.adminOnly": "Only a workspace owner or admin can change this.",
  "settings.appearance.conflict": "Another admin changed the skin a moment ago. The card now shows their choice.",
  "settings.appearance.notSaved": "The skin was not saved. Try again later.",
  "settings.appearance.saveError": "Couldn't save the workspace skin",
  "settings.appearance.section": "Appearance",
  "settings.appearance.skin.ambient": "Ambient",
  "settings.appearance.skin.solid": "Solid",
  "settings.appearance.skinCaption": "Ambient puts a quiet sky behind the home page and frosts the cards. Solid keeps one flat ground, for a branded workspace.",
  "settings.appearance.skinTitle": "Skin",
  "settings.canvas.animations": "Enable animations:",
  "settings.canvas.artboardTitles": "Allow titles on artboard:",
  "settings.canvas.autoCleanConsole": "Auto clean console:",
  "settings.canvas.autoInitialSelection": "Auto initial selection:",
  "settings.canvas.autoPositioning": "Auto positioning:",
  "settings.canvas.autoSelectSidebar": "Auto-select sidebar on selection:",
  "settings.canvas.componentReferences": "Show component references:",
  "settings.canvas.doubleClickOpen": "Double click to open:",
  "settings.canvas.imagePreviews": "Use image previews:",
  "settings.canvas.linkScroll": "Allow links to scroll to pages:",
  "settings.canvas.showGrid": "Show canvas grid:",
  "settings.canvas.teamCursors": "Show team cursors:",
  "settings.canvas.title": "Canvas",
  "settings.canvas.zoomBar": "Enable zoom bar:",
  "settings.codeEditor.debounce": "Editor debounce",
  "settings.codeEditor.folding": "Folding:",
  "settings.codeEditor.fontFamily": "Font family",
  "settings.codeEditor.fontFamilyPlaceholder": "default",
  "settings.codeEditor.fontLigature": "Font ligature:",
  "settings.codeEditor.fontSize": "Font size",
  "settings.codeEditor.lineHeight": "Line height",
  "settings.codeEditor.minimap": "Minimap:",
  "settings.codeEditor.monacoOptions": "Monaco options",
  "settings.codeEditor.tabSize": "Tab size",
  "settings.codeEditor.title": "Code Editor",
  "settings.codeEditor.wordWrap": "Word wrap",
  "settings.footer.autoUpdate": "Auto update canvas",
  "settings.footer.cleanCache": "Clean project cache",
  "settings.footer.cleanCookies": "Clean settings cookies",
  "settings.footer.convertDomql3": "Convert to DOMQL3",
  "settings.footer.cookiesCleared.message": "Cleared all project related cookies from browser",
  "settings.footer.cookiesCleared.title": "Cookies are cleared",
  "settings.footer.resetSettings": "Reset settings",
  "settings.footer.restoreComponents": "Restore missing components",
  "settings.footer.restoreTypes": "Restore missing types",
  "settings.footer.saved.message": "Project settings are updated",
  "settings.footer.saved.title": "Settings are saved",
  "settings.footer.update": "Update",
  "settings.governance.env.development": "Development",
  "settings.governance.env.production": "Production",
  "settings.governance.env.staging": "Staging",
  "settings.governance.link.code": "Code",
  "settings.governance.link.commit": "Commit",
  "settings.governance.link.releaseNotes": "Release notes",
  "settings.governance.link.workflow": "Github workflow",
  "settings.language.adminOnly": "Only a workspace owner or admin can change this.",
  "settings.language.noWorkspace": "No active workspace.",
  "settings.language.notReady": "Not ready yet. Try again.",
  "settings.language.saveError": "Couldn't save the workspace default language",
  "settings.language.section": "Language",
  "settings.language.title": "Interface language",
  "settings.language.workspaceCaption": "Every member sees this language in this workspace.",
  "settings.language.workspaceTitle": "Workspace default language",
  "settings.platform.debugging": "Debugging mode:",
  "settings.platform.defaultTheme": "Default global theme",
  "settings.platform.domql3": "DOMQL3:",
  "settings.platform.enableExplorer": "Enable explorer:",
  "settings.platform.filePreviews": "Enable file sidebar previews:",
  "settings.platform.glassSidebars": "Glass effect on sidebars:",
  "settings.platform.globalTheme": "Global theme",
  "settings.platform.lowPerformance": "Low performance mode:",
  "settings.platform.scrollFilesSidebar": "Scroll files sidebar on active item:",
  "settings.platform.theme.auto": "Auto",
  "settings.platform.theme.dark": "Dark",
  "settings.platform.theme.light": "Light",
  "settings.platform.title": "Platform Options",
  "settings.section.platform": "Platform settings",
  "settings.section.resetTooltip": "Reset to default",
  "settings.sync.forceNavigate": "Force navigate:",
  "settings.sync.forceNavigatePrompt": "Force navigate",
  "settings.sync.forceReload": "Force reload:",
  "settings.sync.forceReloadConfirm": "Do you want to force reload all connected devices?",
  "settings.sync.navigation": "Allow navigation sync:",
  "settings.sync.teamNavigation": "Allow team navigation sync:",
  "settings.sync.title": "Syncing options",
  "settings.tabs.billing": "Billing",
  "settings.tabs.connect": "Connect",
  "settings.tabs.data": "Data",
  "settings.tabs.install": "Install",
  "settings.tabs.settings": "Settings",
  "settings.tabs.sharedLibraries": "Shared Libraries",
  "settings.tabs.versions": "Versions",
  "settings.tip.allowInspecting": "Allow users to inspect elements on the website",
  "settings.tip.animations": "Enable animations during navigating on canvas",
  "settings.tip.artboardTitles": "Allow showing titles when hovering artboards",
  "settings.tip.asyncLoading": "Load data asynchronically during app creation",
  "settings.tip.autoCleanConsole": "Auto clean console on platform updates",
  "settings.tip.autoInitialSelection": "Enable canvas load previously selected component after initial load",
  "settings.tip.autoPositioning": "Enable canvas windows auto positioning",
  "settings.tip.autoSelectSidebar": "Auto switch sidebar when artboard is selected",
  "settings.tip.componentReferences": "Show other places where component is reused",
  "settings.tip.debugging": "Logs and sends notifications on tested actions",
  "settings.tip.domql3": "Use DOMQL3 syntax",
  "settings.tip.doubleClickOpen": "Enable double click to open components from canvas and sidebar",
  "settings.tip.enableExplorer": "Toggle enable file sidebar",
  "settings.tip.fetchData": "Allow symbols server fetching while app is loaded",
  "settings.tip.filePreviews": "Enable preview of components when you mouse over on file sidebar",
  "settings.tip.glassSidebars": "Whether to use glass blurry effect on sidebar items",
  "settings.tip.imagePreviews": "Use thumbnail image previews on components when available to save rendering performance",
  "settings.tip.linkScroll": "Allow canvas to scroll to links with URLs to pages",
  "settings.tip.liveSync": "Allow users to sync platform updates to the website",
  "settings.tip.lowPerformance": "Allow Symbols to optimize canvas for low performance devices",
  "settings.tip.scrollFilesSidebar": "Scroll sidebar when a new component is selected",
  "settings.tip.showGrid": "Enable movable dotted background on the Canvas",
  "settings.tip.syncNavigation": "Sync platform navigation across the devices",
  "settings.tip.syncTeamNavigation": "Sync platform navigation across project members",
  "settings.tip.teamCursors": "Enable showing up team members cursors",
  "settings.tip.zoomBar": "Enable zoom bar on Canvas",
  "settings.voice.adminOnly": "Only a workspace owner or admin can change this.",
  "settings.voice.caption": "The voice the assistant speaks in for every member of this workspace.",
  "settings.voice.current": "Current voice",
  "settings.voice.default": "Default voice",
  "settings.voice.invalid": "This voice is no longer on the voice list. Pick another one.",
  "settings.voice.loadFailed": "The voice list did not load.",
  "settings.voice.loading": "Loading voices…",
  "settings.voice.notSaved": "The voice was not saved. Try again later.",
  "settings.voice.play": "Play sample",
  "settings.voice.retry": "Try again",
  "settings.voice.sampleFailed": "The sample did not play",
  "settings.voice.sampleText": "Hello. This is how the assistant of your workspace sounds.",
  "settings.voice.saveError": "Couldn't save the assistant voice",
  "settings.voice.section": "Voice",
  "settings.voice.stop": "Stop",
  "settings.voice.unprovisioned": "Voice is not set up for this workspace yet.",
  "settings.voice.voiceTitle": "Assistant voice",
  "settings.website.allowInspecting": "Allow inspecting:",
  "settings.website.asyncLoading": "Use async loading:",
  "settings.website.fetchData": "Fetch symbols data:",
  "settings.website.liveSync": "Allow website live sync:",
  "settings.website.title": "Website controls"
}
